import React from "react"
import * as landingStyle from "./landing.module.less"
import officeImg from "../../media/landing-page/office.jpg"
import whoWeAreImg from "../../media/landing-page/how-we-are.png"
import modernizationIcon from "../../media/landing-page/modernization-icon.png"
import TwitterIcon from "../../media/svg/twitter-square.svg"
import {useI18next} from "gatsby-plugin-react-i18next";
import LinkedinIcon from "../../media/svg/linkedin-square.svg"
import {LandingVideo as Landing} from "./landing-video"
import Services from "./services"
import WhyChoose from "./why-choose"
import Footer from "./footer"
import Help from "./help"
import CaseStudies from './case-studies';
import { graphql, StaticQuery } from "gatsby";
import { CustomerOverview } from "../customer-overview/customersOverview";
import { Helmet } from "react-helmet";
import Certificates from "./certificates";
import VideoPane from "./video-pane";
import Simplymeet from "./simplymeet";
import Header from "./header";
import Favicon from "../../media/favicon/x.ico";
import CustomerJourney from './customer-journey';
import Faq from './faq';
import AboutLarge from "./about-large";
import CustomerJourneyTimeline from "./customer-journey-timeline";
import HeroCustomerLogos from "./hero-customer-logos";
import Problems from "./problems";

const AbstractLandingPage = ({
   // testimonials, // This prop is passed but not directly used; CaseStudies uses filteredSuccessStories
   landingContent,
   customServiceSectionContent,
   successStoryCategoriesToShow, // Added new prop
   certificates,
   landingImg,
   isVideoOnLanding,
   services,
   disablePortfolioLink,
   video,
   hideNav,
   defaultBackgroundColor
}) => {
	console.log("landingContent", landingContent);
    const {
        language
    } = useI18next()
    const getNavElements = () => {
       return [
            {
                text: "Portfolio",
                href: "/portfolio"
            },
            {
                text: "Team",
                href: "/employees"
            },
            {
                text: "Blog",
                href: "/blog"
            },
            {
                text: "Success Stories",
                href: "/success-stories"
            }
        ]
    }
	const scriptContent = `
    (function(d, w, b, t){
      var h = d.getElementsByTagName("head")[0];
      var s = d.createElement("script");
      s.src = b + "/t/script.js?c=" + t;
      h.appendChild(s);
    })(document, window, "https://ltracking.de", "${process.env.UTM_ID}");
  `;

    // Hardcoded props for About and WhyChoose after refactor
    const aboutProps = {
        heading: "WER WIR SIND",
        //btn: { text: "Mehr über das Team", href: "/de/employees/" }, // Updated Button Text
        btn: {
          text: "Kostenloses Erstgespräch anfragen" || landingContent.btn.text,
          shouldBreak: true,
          href: landingContent.btn.href
        },
        img: whoWeAreImg // Use the imported image
    };

    const whyChooseProps = {
        header: "Warum",
        teamName: "TEAM PARALLAX",
        backgroundImage: officeImg // Use the imported image
    };

    return (
        <StaticQuery
            query={graphql`
              query {
                customers: allMarkdownRemark(
                  sort: { fields: [frontmatter___order], order: ASC }
                  filter: {
                    frontmatter: {
                    	isDraft: { ne: true }
                    	category: { eq: "customers" }
					}
                  }
                ) {
                  totalCount
                  edges {
                    node {
                      id
                      frontmatter {
                        name
                        link
                        imagePath {
                          publicURL
                          childImageSharp {
                            gatsbyImageData(
                              width: 200
                              layout: CONSTRAINED
                            )
                          }
                        }
                      }
                      fields {
                        slug
                      }
                    }
                  }
                }
                generalInformation: allMarkdownRemark(
                  sort: { fields: [frontmatter___order] }
                  filter: {
                    frontmatter: { 
                      isDraft: { ne: true } 
                      category: { eq: "general-information" }
                    }
                  }
                ) {
                  totalCount
                  edges {
                    node {
                      id
                      frontmatter {
                        phone
                        address
                      }
                    }
                  }
                }
                successStory: allMarkdownRemark(
                  filter: {
                    frontmatter: {
                      category: { eq: "successStory" }
                      publish: { eq: true }
                    }
                  }
                ) {
                  edges {
                    node {
                      html
                      fields {
                        language
                        slug
                      }
                      frontmatter {
                        companyName
                        baselineSituationPoints
                        resultsPoints
                        website
                        sector
                        employees
                        categories
                        location
                        publish
                        mockupType
                        imagePath {
                          publicURL
                          childImageSharp {
                            gatsbyImageData(
                              width: 200
                              layout: CONSTRAINED
                            )
                          }
                        }
                        imageDarkPath {
                          publicURL
                          childImageSharp {
                            gatsbyImageData(
                              width: 200
                              layout: CONSTRAINED
                            )
                          }
                        }
                        screenShot {
                          publicURL
                          childImageSharp {
                            gatsbyImageData(
                              width: 600
                              layout: CONSTRAINED
                            )
                          }
                        }
                      }
                    }
                  }
                }
              }
            `}
            render={ data => {
                const information = data.generalInformation.edges[0].node.frontmatter

                // REMOVE Filtering logic
                // const socialProofCustomers = testimonialIds && data.customers.edges ? ... : [];

                // USE Raw customer data directly
                const socialProofCustomers = data.customers.edges;

                // console.log("LandingPage: Using ALL Customers for Hero Logos:", socialProofCustomers.length);

                const allSuccessStoriesFromQuery = data.successStory.edges;

                const languageFilteredStories = allSuccessStoriesFromQuery.filter(
                    edge => edge.node.fields.language === language
                );

                let storiesForPage = languageFilteredStories;
                if (successStoryCategoriesToShow && successStoryCategoriesToShow.length > 0) {
                    storiesForPage = languageFilteredStories.filter(edge => {
                        const storyCategories = edge.node.frontmatter.categories || [];
                        return successStoryCategoriesToShow.some(cat => storyCategories.includes(cat));
                    });
                }

                // The prop passed to CaseStudies was 'filteredSuccesStories', renaming for clarity
                const caseStudiesToDisplay = storiesForPage.map(edge => {
                  const { node } = edge;
                  const { frontmatter } = node;
                  // Check if screenShot exists and has been processed by Sharp
                  if (frontmatter.screenShot && frontmatter.screenShot.childImageSharp) {
                    // Create a new node object with the updated imagePath
                    const newNode = {
                      ...node,
                      frontmatter: {
                        ...frontmatter,
                      },
                    };
                    return { ...edge, node: newNode };
                  }
                  return edge; // No screenShot or it's invalid, return original edge
                });


                return(
                    <div className={landingStyle.container}>
						<Helmet>
							<title>Für alle Unternehmer | Team Parallax</title>
							<link rel="icon" type="image/png" href={ Favicon } sizes="16x16"/>
							<script>{scriptContent}</script>
						</Helmet>
						<header>
							<Header
								navElements={getNavElements() }
                                hideNav={hideNav}
                                ctaButton={landingContent.btn}
							/>
						</header>
						{ isVideoOnLanding
							? (
								<Landing
									video={video}
                                    videoProps={ {
                                        controls: true,
                                        muted: false
                                    } }
                                    isFullSize={ true }
                                    navElements={getNavElements()}
                                    backgroundImageUrl={ landingImg }
                                    headerBtn={ {
                                        text: "Contact",
                                        onClick: () => undefined,
                                        href: "/de/contact"
                                    } }
                                    content={ landingContent }
                                    socialProofCustomers={ socialProofCustomers }
                                    defaultBackgroundColor={defaultBackgroundColor}
                                />
                            )
                            : (
                                <Landing
                                    navElements={getNavElements()}
                                    backgroundImageUrl={ landingImg }
                                    headerBtn={ {
                                        text: "Contact",
                                        onClick: () => undefined,
                                        href: "/de/contact"
                                    } }
                                    content={ landingContent }
                                    socialProofCustomers={ socialProofCustomers }
                                    defaultBackgroundColor={defaultBackgroundColor}
                                />
                            )
                        }
                        {landingContent.problems && (
                            <Problems
                                problemProps={landingContent.problems}
                                backgroundColor={'#f6fafe'}
                            />
                        )}
                        <CustomerOverview
                            data={data.customers.edges}
                            useMarquee={true}
                            backgroundColor={'#092b4d'}
							isFontColorWhite
                        />
                        {/*
                        {customServiceSectionContent && customServiceSectionContent.title && (
                            <Services
                                heading={customServiceSectionContent.title}
                                description={customServiceSectionContent.description}
                                services={services}
                                btn={ undefined }
                            />
                        )}
                        { video && !isVideoOnLanding && (
                            <VideoPane
                                heading={"Kurz und Knapp"}
                                description={"Es braucht nicht lange, um einen Eindruck zu hinterlassen. In nur 90 Sekunden zeigen wir Ihnen, warum wir die richtige Wahl für Sie sind."}
                                video={ video }
                                videoProps={ {
                                    controls: true,
                                    muted: false
                                } }
                                isFullSize={ true }
                                videoErrormessage={ "Ihr Browser kann dieses Video nicht wiedergeben. Dieses Video zeigt den Big Buck Bunny Film." }
                                backgroundImage={ officeImg }
                            />
                        )}
                        <Help
                            heading="Wie wir helfen: Schnelles Prototyping"
                            description="Wir bringen Ihre digitale Idee zum Leben. Mit einem interaktiven Prototyp können Sie Ihr Konzept schnell validieren, Feedback sammeln und Investoren überzeugen - alles innerhalb weniger Tage."
                            services={ [
                                {
                                    icon: modernizationIcon,
                                    title: "PROTOTYPING SERVICE",
                                    description: "Erhalten Sie einen klickbaren Prototyp Ihrer Web- oder Mobile-App-Idee in nur 5 Werktagen."
                                }
                            ] }
                            text="Fokus auf schnelle Validierung und praxisnahes Feedback."
                        />
                        <WhyChoose {...whyChooseProps} />
                        */}
                        <AboutLarge
                            {...aboutProps}
                            backgroundColor={'#f6fafe'}
                        />
                        <CustomerJourney
                            heading={landingContent.processHeading}
                            journeySteps={landingContent.processSteps}
                            backgroundColor={'#092b4d'}
                        />
                        {/*
                        { certificates && (
                            <Certificates
                                heading="Wir sind zertifiziert"
                                description="Unser Team verfügt über Zertifikate in den verschiedensten Bereichen um die beste Expertise für unsere Kunden zu haben."
                                certificates={ certificates } />
                        )}
                        */}
                        { caseStudiesToDisplay && caseStudiesToDisplay.length > 0 && (
                            <CaseStudies
                                heading="Fallstudien"
                                description="von unseren Kunden"
                                studies={caseStudiesToDisplay}
                                backgroundColor={'#f6fafe'}
                            />
                        )}
                        <Simplymeet
                            heading={"LET'S GET STARTED"}
                            description={"Ein Projekt oder eine Partnerschaft ist geplant? Vereinbaren Sie direkt ihren Termin zu einem ersten Kennenlernen mit Team Parallax"}
                            backgroundColor={'#092b4d'}
                        />
                        { landingContent.faq && (
                            <Faq
                                faqData={landingContent.faq}
                                backgroundColor={'#f6fafe'}
                            />
                        )}
                        <Footer
                            socialIcons={ [
                                {
                                    icon: <LinkedinIcon/>,
                                    href: "https://www.linkedin.com/company/team-parallax"
                                }
                            ] }
                            links={ [] }
                            // links={ getNavElements() }
                            address={ information.address }
                            phone={ information.phone }
                            isDark
                        />
                    </div>
                )}}
        >

        </StaticQuery>
    )
}
export default AbstractLandingPage
